/**
 * API client for Campuses endpoints
 */

import apiClient from "./client";
import type {
  Campus,
  CampusListResponse,
  CreateCampusRequest,
  UpdateCampusRequest,
  ListCampusesParams,
  MessageResponse,
} from "@/types/campus";

/**
 * Campuses API endpoints
 */
export const campusesApi = {
  /**
   * List all campuses
   */
  list: (params?: ListCampusesParams) =>
    apiClient.get<CampusListResponse>("/api/tenants/v1/campuses", { params }),

  /**
   * List campuses for public application (no authentication required)
   */
  listPublic: (tenantId: string) =>
    apiClient.get<CampusListResponse>("/api/tenants/v1/public/campuses", {
      params: { tenant_id: tenantId },
    }),

  /**
   * Get campus by ID
   */
  get: (id: string) => apiClient.get<Campus>(`/api/tenants/v1/campuses/${id}`),

  /**
   * Create new campus
   */
  create: (data: CreateCampusRequest) =>
    apiClient.post<Campus>("/api/tenants/v1/campuses", data),

  /**
   * Update campus
   */
  update: (id: string, data: UpdateCampusRequest) =>
    apiClient.patch<Campus>(`/api/tenants/v1/campuses/${id}`, data),

  /**
   * Archive campus (soft delete)
   */
  delete: (id: string) =>
    apiClient.delete<MessageResponse>(`/api/tenants/v1/campuses/${id}`),
};

export default campusesApi;
